"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MSG_NAMESPACE = void 0;
exports.MSG_NAMESPACE = 'HIP-COMMUNICATOR';
